export default "__VITE_PUBLIC_ASSET__502e17a6__"